import React, { useContext } from 'react';
import useReportCSS from '../../useReportCSS';
import DetailsOpReportContext from './DetailsOpReportContext';
import DetailsOpReportQuestion from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerTable(props) {
    const { questions, hasIssues = false, hasNotes = false, hideHeadingRow = false, unrestrictedQuestionIds = [], } = props;
    const { def } = useContext(DetailsOpReportContext);
    const myCss = useReportCSS(def.pdf);
    let colWidth = 70;
    if (hasNotes) {
        colWidth = colWidth - 20;
    }
    if (hasIssues) {
        colWidth = colWidth - 20;
    }
    return (React.createElement("table", { className: myCss.table },
        React.createElement("tbody", null,
            hideHeadingRow && (React.createElement("tr", { className: myCss.row },
                React.createElement("th", { style: { width: colWidth + '%' }, colSpan: 10 }),
                React.createElement("th", { style: { width: '30%' } }),
                hasIssues && React.createElement("th", { style: { width: '20%' } }),
                hasNotes && React.createElement("th", { style: { width: '20%' } }))),
            !hideHeadingRow && (React.createElement("tr", { className: myCss.row },
                React.createElement("th", { className: myCss.heading + ' ' + myCss.left, style: { width: colWidth + '%' }, colSpan: 10 }, "Question"),
                React.createElement("th", { className: myCss.heading + ' ' + (hasIssues || hasNotes ? '' : myCss.right), style: { width: '30%' } }, "Response"),
                hasIssues && (React.createElement("th", { className: myCss.heading + ' ' + myCss.right, style: { width: '20%' } }, "Issues")),
                hasNotes && (React.createElement("th", { className: myCss.heading + ' ' + myCss.right, style: { width: '20%' } }, "Notes")))),
            questions.map(q => (React.createElement(DetailsOpReportQuestion, { key: q.nodeId, questionNodeId: q.nodeId, isRestricted: !(unrestrictedQuestionIds === null || unrestrictedQuestionIds === void 0 ? void 0 : unrestrictedQuestionIds.includes(q.nodeId)) }))))));
}
export default DetailsOpReportAnswerTable;
